import { Box, Text, VStack } from '@chakra-ui/react';
import { useQueryClient } from '@tanstack/react-query';
import { AnimatePresence } from 'framer-motion';
import React from 'react';

import type { SocketMessage } from 'lib/socket/types';
import type { Transaction } from 'types/api/transaction';

// import { route } from 'nextjs-routes';

import useApiQuery, { getResourceKey } from 'lib/api/useApiQuery';
import { AddressHighlightProvider } from 'lib/contexts/addressHighlight';
import useIsMobile from 'lib/hooks/useIsMobile';
// import useNewTxsSocket from "lib/hooks/useNewTxsSocket";
import useSocketChannel from 'lib/socket/useSocketChannel';
import useSocketMessage from 'lib/socket/useSocketMessage';
import { TX } from 'stubs/tx';
// import LinkInternal from 'ui/shared/links/LinkInternal';
// import SocketNewItemsNotice from "ui/shared/SocketNewItemsNotice";

import LatestTxsItemMobile from './LatestTxsItemMobile';

// import LatestTxsItemMobile from "./LatestTxsItemMobile";

const LatestTransactions = () => {
  const isMobile = useIsMobile();
  const txsCount = isMobile ? 2 : 3;
  const { data, isPlaceholderData, isError } = useApiQuery('homepage_txs', {
    queryOptions: {
      placeholderData: Array(txsCount).fill(TX),
    },
  });
  const queryClient = useQueryClient();
  const blocksMaxCount = 6;

  const handleNewTransactionMessage: SocketMessage.NewBlock['handler'] =
    React.useCallback(
      async(payload) => {
        const res = await fetch(
          `https://ogpuscan.io/api/v2/blocks/${ payload.block.height }/transactions`,
        );
        /* eslint-disable @typescript-eslint/no-explicit-any */
        const fixed: any = await res.json();
        /* eslint-enable @typescript-eslint/no-explicit-any */
        const txs = fixed.items;
        queryClient.setQueryData(
          getResourceKey('homepage_txs'),
          (prevData: Array<Transaction> | undefined) => {
            const newData = prevData ? [ ...prevData ] : [];
            return [ ...txs, ...newData ]
              .sort(
                (b1, b2) =>
                  new Date(b2.timestamp).getTime() -
                  new Date(b1.timestamp).getTime(),
              )
              .slice(0, blocksMaxCount);
          },
        );
      },
      [ queryClient ],
    );

  const channel = useSocketChannel({
    topic: 'blocks:new_block',
    isDisabled: isPlaceholderData || isError,
  });
  useSocketMessage({
    channel,
    event: 'new_block',
    handler: handleNewTransactionMessage,
  });
  // const { num, socketAlert } = useNewTxsSocket();
  if (isError) {
    return <Text mt={ 4 }>No data. Please reload the page.</Text>;
  }

  if (data) {
    const content = (
      <VStack
        spacing={ 2 }
        mb={ 3 }
        overflow="hidden"
        alignItems="stretch"
        gap="21px"
      >
        <AnimatePresence initial={ false }>
          { data.slice(0, txsCount).map((tx, index) => (
            <LatestTxsItemMobile
              key={ tx.hash + (isPlaceholderData ? index : '') }
              tx={ tx }
              isLoading={ isPlaceholderData }
            />
          )) }
        </AnimatePresence>
      </VStack>
    );

    return (
      <>
        { /* <SocketNewItemsNotice
          borderBottomRadius={0}
          url={txsUrl}
          num={num}
          alert={socketAlert}
          isLoading={isPlaceholderData}
        /> */ }

        <Box mb={ 3 } display={{ base: 'block' }}>
          <AddressHighlightProvider>{ content }</AddressHighlightProvider>
        </Box>
      </>
    );
  }

  return null;
};

export default LatestTransactions;
